import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, CardMedia, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@shared/components/contents/link/Link";
import dayjs from "dayjs";
const ProjectArticleSubpage = ({ page }) => {
    const { id, title, image, publishedDate: date } = page;
    return (_jsxs(Card, { component: Link, page: page, sx: {
            display: "block",
            height: "100%",
            border: "solid 1px",
            borderColor: "border.grey",
            boxShadow: "none",
            "&:hover, &:focus": {
                border: "solid 1px",
                borderColor: "border.soft",
                textDecoration: "none",
            },
        }, children: [image && (_jsx(CardMedia, { component: "img", image: image.url, alt: image.alt || "", title: image.title, sx: { height: 160, objectFit: "cover" } })), _jsx(CardContent, { sx: { p: 3 }, children: _jsxs(Stack, { spacing: 2, children: [title && (_jsx(Typography, { variant: "subtitle1", component: "p", fontWeight: 600, children: title })), _jsx(Divider, { sx: { backgroundColor: "text.primary" } }), date && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: dayjs(date).format("D MMMM YYYY") }))] }) })] }));
};
export default ProjectArticleSubpage;
